<div class="form-datepicker">
    <input
        ngbDatepicker
        #datepicker
        #d="ngbDatepicker"
        class="form-control"
        type="text"
        placeholder="dd-mm-jjjj"
        [id]="id"
        [disabled]="disabled"
        [required]="required"
        [minDate]="minimumDate"
        [maxDate]="maxDate"
        (focus)="toggle()"
        (click)="toggle()"
        (blur)="onBlur()"
        (dateSelect)="onSelect($event)"
        [dayTemplate]="t"
        [autoClose]="false"
        autocomplete="off"
        readonly
    />
    <div class="form-datepicker__icon" (click)="toggle()">
        <svg class="svg-icon svg-icon--xs svg-icon--secondary"><use href="assets/icons-ui.svg#kalender"></use></svg>
    </div>
</div>

<ng-template #t let-date="date" let-focused="focused" let-currentMonth="currentMonth" let-today="today">
    <span
        class="dp-day"
        [class.today]="today"
        [class.dp-outside]="isPast(date)"
        [class.dp-focused]="focused"
        [class.dp-not-active]="date.month !== currentMonth"
    >
        {{ date.day }}
    </span>
</ng-template>
